export default __webpack_public_path__ + "static/media/feature-item-live-score.b586c11d.svg";